<template>
  <BaseCard
    v-if="showComponent"
    :heading="$t('global.required')"
    v-test="'tw-dac7-verification-card'"
  >
    <Flex
      align="center"
      direction="column"
    >
      <img
        :class="$style.visual"
        src="/img/treatwell/monitor.svg"
      >
      <BaseText center>
        {{ $t('treatwell_dac7_verification.issues_found') }}
      </BaseText>
      <BaseButton
        color="inverted"
        :routerLink="{ name: 'treatwell-salon-info' }"
        v-test="'tw-dac7-verification-cta'"
        @click="onCtaClick"
      >
        {{ $t('treatwell_dac7_verification.complete') }}
      </BaseButton>
    </Flex>
  </BaseCard>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { segment } from '@/segment';
import { useTreatwellStore } from '@/stores/treatwell';

const { onlyMissingCompanyInfo: showComponent } = storeToRefs(
  useTreatwellStore(),
);

const onCtaClick = () => {
  segment.track('market_place.dac7_verification.cta.clicked');
};
</script>

<style
  lang="scss"
  module
>
.visual {
  width: 180px;
}
</style>
